import cn from 'classnames'
import React, { ComponentProps } from 'react'

type ReceiptPushFailedProps = {
  className?: string
} & ComponentProps<'svg'>

export default function ReceiptPushFailed(props: ReceiptPushFailedProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('ReceiptPushFailed', className)}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      {...rest}
    >
      <g clipPath="url(#ReceiptPushFailed_svg__a)">
        <path
          fill="#D5404A"
          d="M11.75 2.25c5.385 0 9.75 4.365 9.75 9.75 0 .231-.012.46-.027.688h-1.504q.029-.34.031-.688a8.25 8.25 0 1 0-5.312 7.709v1.589a9.7 9.7 0 0 1-2.938.452C6.365 21.75 2 17.385 2 12s4.365-9.75 9.75-9.75m0 14.002a.75.75 0 0 1 .742.64l.008.11v.423a.75.75 0 0 1-1.492.111L11 17.425v-.423a.75.75 0 0 1 .75-.75m0-9.992a.75.75 0 0 1 .742.64l.008.11v7.175a.75.75 0 0 1-1.492.11l-.008-.11V7.01a.75.75 0 0 1 .75-.75"
        />
        <path
          fill="#D5404A"
          stroke="#D5404A"
          strokeLinecap="round"
          strokeWidth={0.625}
          d="M16.667 22.109v-7.65c0-.23.186-.418.416-.418h5.834c.23 0 .416.187.416.417v7.65a.208.208 0 0 1-.349.154l-1.187-1.09a.21.21 0 0 0-.27-.01l-1.398 1.1a.21.21 0 0 1-.258 0l-1.398-1.1a.21.21 0 0 0-.27.01l-1.187 1.09a.208.208 0 0 1-.35-.153Z"
        />
        <path
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth={0.76}
          d="M17.917 15.5H22.5m-4.583 1.875H20.5"
        />
      </g>
      <defs>
        <clipPath id="ReceiptPushFailed_svg__a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
